import React, { useState } from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { useToggle } from 'react-use';
import { ListPickerButton, SearchView } from './components';

const ListPicker = (props) => {
  const [isPopupOpened, togglePopup] = useToggle(false);
  const {
    value,
    inputValue,
    onChange,
    onInputChange,
    onSearch,
    onOpen,
    label,
    options,
    required,
    helperText,
    getOptionLabel,
    SearchViewProps,
    ListPickerButtonProps,
  } = props;
  const [draftValue, setDraftValue] = useState(value);
  const textHelp =
    typeof helperText === 'object' && Array.isArray(helperText)
      ? helperText[0].name
      : helperText;

  const handleOpen = () => {
    setDraftValue(value);
    onInputChange(null, '');
    togglePopup(true);
    onOpen();
  };

  const handleClose = (event) => {
    onInputChange(event, '');
    togglePopup(false);
  };

  const handleApply = (event) => {
    onChange(event, draftValue);
    onInputChange(event, '');
    togglePopup(false);
  };

  const renderPickerButton = () => {
    const {
      FormControlProps,
      InputLabelProps,
      FormHelperTextProps,
      ...restPickerButtonProps
    } = ListPickerButtonProps;

    return (
      <ListPickerButton
        label={label}
        options={value}
        helperText={textHelp}
        getOptionLabel={getOptionLabel}
        FormControlProps={{
          required,
          margin: 'normal',
          fullWidth: true,
          ...FormControlProps,
        }}
        InputLabelProps={{ required, ...InputLabelProps }}
        FormHelperTextProps={{
          required,
          ...FormHelperTextProps,
        }}
        onClick={handleOpen}
        {...restPickerButtonProps}
      />
    );
  };

  const renderSearchView = () => {
    return (
      <>
        <SearchView
          open={isPopupOpened}
          value={draftValue}
          options={options}
          inputValue={inputValue}
          getOptionLabel={getOptionLabel}
          onChange={(event, newValue) => setDraftValue(newValue)}
          onInputChange={onInputChange}
          onClose={handleClose}
          onApply={handleApply}
          onSearch={onSearch}
          {...SearchViewProps}
        />
      </>
    );
  };

  return <>{isPopupOpened ? renderSearchView() : renderPickerButton()}</>;
};

/**
 * See [Autocomplete](https://material-ui.com/api/autocomplete/)
 * all available autocomplete option
 */
ListPicker.propTypes = {
  value: Type.arrayOf(Type.oneOfType([Type.object, Type.string])),
  inputValue: Type.string.isRequired,
  onChange: Type.func.isRequired,
  onInputChange: Type.func.isRequired,
  onSearch: Type.func,
  onOpen: Type.func,
  label: Type.string,
  helperText: Type.string,
  options: Type.arrayOf(Type.oneOfType([Type.object, Type.string])),
  required: Type.bool,
  getOptionLabel: Type.func,
  SearchViewProps: Type.shape(SearchView.propTypes),
  ListPickerButtonProps: Type.shape(ListPickerButton.propTypes),
};

ListPicker.defaultProps = {
  value: [],
  label: undefined,
  helperText: undefined,
  required: false,
  options: [],
  getOptionLabel: (option) => option,
  SearchViewProps: {},
  ListPickerButtonProps: {},
  onSearch: noop,
  onOpen: noop,
};

export default ListPicker;
